import type { JSX } from "react";
import { UserRolesEnum } from "../app/enums/userRolesEnum";
import { useAuth } from "./useAuth";

export const useUserRole = () => {
    const { session } = useAuth();

    const hasRole = (requiredRoles: Array<UserRolesEnum>) => {
        if (!session || session.roles.length === 0) return false;
        return requiredRoles.some((role) => session.roles.includes(role));
    };

    const renderIfHasRole = (element: JSX.Element, requiredRoles: Array<UserRolesEnum>) => {
        if (hasRole(requiredRoles)) return element;
        return undefined;
    };

    return { session, hasRole, renderIfHasRole };
};
